import { gql } from '@apollo/client';

export const MAPKIT_TOKEN_QUERY = gql`
    query mapkitToken {
        mapkitToken
    }
`;
